import { ProductType } from '@/types';
import { WarningTypes } from './warningTypes';

export const getHasWarning = (productType: ProductType, warning: WarningTypes) =>
  productType.labels?.warningIds.includes(warning);
